<template>
  <MainLayout
    :initialDrawerExpanded="false"
    contentClass="pa-md-4"
    :has-sidebar="false"
  >
    <template #header>
      <div class="overline">
        <PageBack />
      </div>
    </template>

    <template #content>
      <v-container fluid class="pa-0 pa-md-4">
        <v-row>
          <v-col cols="12" md="8" offset-md="2">
            <h2 class="mb-4">
              <v-icon class="mr-2">mdi-sync</v-icon>
              Synchronisation Google Drive → OpenAI
            </h2>
            <sync-panel />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </MainLayout>
</template>

<script>
import PageBack from '@/components/ui/PageBack.vue'
import MainLayout from '@/layout/MainLayout.vue'
import SyncPanel from '@/components/sync/SyncPanel.vue'

export default {
  name: 'SyncView',
  components: { PageBack, MainLayout, SyncPanel },
}
</script>
